// import {} from '../../service'

const dynview_tag_mixins = {
  data() {
    return {}
  },
  computed: {
    new_tags() {
      let dynview_tag = this.dynview_tag
      let tag_array_1 = []
      let tag_array_2 = []
      let tag_array_3 = []
      dynview_tag.map((a) => {
        if(a.pid == null){
          tag_array_1.push(a)
        }
        if(a.pid != null && a.pgid == null){
          tag_array_2.push(a)
        }
        if(a.pgid != null){
          tag_array_3.push(a)
        }
      })
      tag_array_2.map((a) => {
        let i = tag_array_1.findIndex((b) => {return b.id == a.pid})
        if(i > -1) a.type_id = tag_array_1[i].type_id
      })
      tag_array_3.map((a) => {
        let i = tag_array_1.findIndex((b) => {return b.id == a.pgid})
        if(i > -1) a.type_id = tag_array_1[i].type_id
      })
      // console.log([].concat(tag_array_1,tag_array_2,tag_array_3))
      return [].concat(tag_array_1,tag_array_2,tag_array_3)
    }
  },
  methods: {}
}

export { dynview_tag_mixins }
